<section>
  <app-settings-tabs *ngIf="isSettingsRoute"></app-settings-tabs>
  <app-masters-tabs *ngIf="isMastersRoute"></app-masters-tabs>
  <!-- <app-workflows-tabs *ngIf="isWorkflowsRoute"></app-workflows-tabs> -->

  <header [class]="isHeaderExpanded ? 'bg-dark text-white' : 'text-white'">
    <div class="container-fluid">
      <div class="row align-items-center">
        <div
          class="col-md-1 d-flex align-items-center"
          [class.p-0]="!isHeaderExpanded"
        >
          <!-- <i class="ri-grid-fill mx-2 cursor-pointer" (click)="toggleSidebar()"></i> -->
          <div
            class="hamburger-wrapper"
            (click)="toggleHeader()"
            [class.collapsed]="!isHeaderExpanded"
          >
            <img src="../../../assets/icons/hamburger.png" alt="" />
          </div>

          <img
            *ngIf="isHeaderExpanded"
            src="./../../../assets/images/Frame 182.png"
            alt=""
            class="mx-2 cursor-pointer"
            [routerLink]="
              userDetails?.designation === 'Caratred Supervisor'
                ? '/home/company'
                : '/home/products'
            "
          />
        </div>
        <div class="col-md-6 px-5" *ngIf="isHeaderExpanded">
          <div class="footer-tabs gap-4 d-flex align-items-center">
            <div
              class="footer-tab-item"
              [class.active]="activeTab === 'home'"
              (click)="activeTab = 'home'"
              *ngIf="userDetails?.designation !== 'Caratred Supervisor'"
              [routerLink]="['/home/products']"
            >
              <span>Home</span>
            </div>
            <!-- <div
              class="footer-tab-item"
              [class.active]="activeTab === 'workflows'"
              (click)="activeTab = 'workflows'"
              [routerLink]="['/home/workflow']"
            >
              <span>Workflows</span>
            </div> -->
            <div *ngIf="canShowSettingsTab"
              class="footer-tab-item"
              [class.active]="activeTab === 'masters'"
              (click)="activeTab = 'masters'; activemasterTab = 'employees'"
              [routerLink]="['/home/users']"
            >
              <span>Masters</span>
            </div>
            <div
              *ngIf="canShowSettingsTab"
              class="footer-tab-item"
              [class.active]="activeTab === 'settings'"
              (click)="activeTab = 'settings'; activeSettingsTab = 'general'"
              [routerLink]="['/home/settings']"
            >  <span>Settings</span>
            </div>
          </div>
        </div>
        <div class="col-md-4" [hidden]="!isHeaderExpanded">
          <ng-container>
            <app-hospitality-unit
              (selectionChange)="onHotelSelect($event)"
            ></app-hospitality-unit>
          </ng-container>
        </div>
        <div class="col-md-1 text-right" *ngIf="isHeaderExpanded">
          <!-- <i class="ri-notification-4-fill mx-3"></i> -->

          <div ngbDropdown class="btn-group wotToggleDrDwn text-dark">
            <button
              class="btn btn-sm border btn-block border-0 emp-name"
              id="userDropdown"
              ngbDropdownToggle
            >
              <strong> {{ getInitials(userDetails?.emp_name) }}</strong>
            </button>

            <!-- IMPORTANT: use ngbDropdownMenu, not raw .dropdown-menu -->
            <div
              ngbDropdownMenu
              class="dropdown-menu "
              aria-labelledby="userDropdown"
            >
              <div class="d-flex align-items-center px-3 my-3">
                <p class="user_icon">
                  {{ getInitials(userDetails?.emp_name) }}
                </p>
                <li class="btnuser mx-2 f-15">
                  <strong> {{ userDetails?.emp_name }}</strong>
                </li>
              </div>

              <li class="btnuser d-flex align-items-center px-3 my-3">
                <i class="ri-mail-line me-2 f-17"></i>
                <span class="f-14" ngbTooltip="{{ userDetails?.name }}" placement="top">{{ userDetails?.name }}</span>
              </li>
              <p class="my-3 d-flex align-items-center px-3 ">
               <i class="ri-briefcase-line me-2 f-17"></i>
                <span class="f-14">{{ userDetails?.designation }}</span>
              </p>
              <div class="d-flex">
                <button
                  class="btn-sm btnoutlineprimary border-radius-change text-center"
                  (click)="changePassword()"
                  ngbDropdownItem
                >
                  Change Password
                </button>

                <button
                  class="btn-sm btn-primary w-100 f-14 border-radius-sign text-center"
                  (click)="logout()"
                  ngbDropdownItem
                >
               <strong>  Logout</strong>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </header>
</section>
